<script>

import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import { useDonationsPublicStore } from '@/stores/donationPublic.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwCardWithBackdrop from '@/components/generic/tw-card-with-backdrop.vue'
import TwButton from '@/components/generic/tw-button.vue'
import DonationPublicDetails from '@/components/donations/donation-public-details.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserPageSocialsShare from '@/components/fundraiser-pages/fundraiser-page-socials-share.vue'
import FundraiserSocialsShare from '@/components/fundraisers/fundraiser-socials-share.vue'
export default {
  name: 'FundraiserDonationReturnPagePublicPage',
  components: { FundraiserSocialsShare, FundraiserPageSocialsShare, TwModal, DonationPublicDetails, TwButton, TwCardWithBackdrop, TwLoadingSpinner, TwTransitionContainer },
  mixins:[fundraiserPublicFetchMixin],
  props: {
    donationId: {
      type: Number,
      required: true
    },
  },
  computed: {
    donation() {
      return useDonationsPublicStore().getItemById(this.donationId)
    }
  },
  mounted() {
    useDonationsPublicStore().fetchItemById(this.donationId)
    useDonationsPublicStore().processCheckout(this.donationId)
  },
  methods: {
    closed() {
      this.$router.push({ name: 'FundraiserPublicPage', params: { fundraiserId: this.fundraiser.id, slug: this.fundraiser.slug } })
    }
  }
}
</script>

<template>
  <tw-transition-container>
    <tw-card-with-backdrop v-if="fundraiser && donation" :backdrop-url="fundraiser.cover_image_url" show-close-button @close="closed">
      <div class="flex flex-row justify-center mt-10">
        <icon icon="check-circle" class="h-14 text-blue-600" />
      </div>
      <div class="text-center my-8 flex flex-col gap-2">
        <h2>
          Thank you!
        </h2>
        <h4>Your donation was successfully processed. </h4>
        <p>You can help advance your impact by helping spread the word about this campaign. </p>
      </div>
      <div class="mt-4 px-5">
        <tw-button variant="amber" block size="lg" @click="$refs.shareModal.open()">
          Help Spread The Word
        </tw-button>
      </div>
      <donation-public-details :donation="donation" />
      <div class="flex justify-center my-10">
        <img :src="fundraiser.logo_url" class="w-48">
      </div>
      <div class="text-center text-xs">
        Your donation is safe and secure. All proceeds of your donation will go directly to <span class="font-semibold">{{ fundraiser.cached.beneficiary_name }}</span>
      </div>
      <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
        <fundraiser-socials-share :fundraiser="fundraiser" />
      </tw-modal>
    </tw-card-with-backdrop>
    <tw-loading-spinner v-else />
  </tw-transition-container>
</template>

<style scoped>

</style>
